import { z } from 'zod';

import {
  SERIAL_VALIDATE,
  SERIAL_VALIDATE_REGEX,
  SERIAL_VALIDATE_MESSAGES,
} from '../../serial/constants/index';

/**
 * シリアルリンク：バリデーション
 */
export const SERIAL_LINK_VALIDATE = SERIAL_VALIDATE;

/**
 * シリアルリンク：バリデーション定義
 */
export const SERIAL_LINK_FORM_SCHEMA = z.object({
  serialLink: z
    .string()
    .min(SERIAL_LINK_VALIDATE.LENGTH.MIN, SERIAL_VALIDATE_MESSAGES.LENGTH)
    .max(SERIAL_LINK_VALIDATE.LENGTH.MAX, SERIAL_VALIDATE_MESSAGES.LENGTH)
    .regex(SERIAL_VALIDATE_REGEX, {
      message: SERIAL_VALIDATE_MESSAGES.FORMAT,
    }),
});
export type SerialLinkForm = z.infer<typeof SERIAL_LINK_FORM_SCHEMA>;

/**
 * シリアル連携状態
 */
export const SERIAL_LINK_STATUS = {
  // 何もしていない
  NONE: 'NONE',
  // 無効なシリアル
  INFO_INVALID_LICENSE: 'INFO_INVALID_LICENSE',
  // 期限切れのシリアル
  INFO_EXPIRED_LICENSE: 'INFO_EXPIRED_LICENSE',
  // 連携済のシリアル
  INFO_ALREADY_LINKED: 'INFO_ALREADY_LINKED',
  // エラー
  ERROR: 'ERROR',
  // 成功
  SUCCESS: 'SUCCESS',
};
export type SerialLinkStatusType =
  (typeof SERIAL_LINK_STATUS)[keyof typeof SERIAL_LINK_STATUS];

/**
 * シリアル連携エラーメッセージ
 */
export const SerialErrorMessageMap: { [key in SerialLinkStatusType]: string } =
  {
    [SERIAL_LINK_STATUS.NONE]: '',
    [SERIAL_LINK_STATUS.INFO_INVALID_LICENSE]:
      '登録/更新に失敗しました。無効なシリアルです。',
    [SERIAL_LINK_STATUS.INFO_EXPIRED_LICENSE]:
      '登録/更新に失敗しました。期限切れのシリアルです。',
    [SERIAL_LINK_STATUS.INFO_ALREADY_LINKED]:
      '登録/更新に失敗しました。すでに連携済のシリアルです。',
    [SERIAL_LINK_STATUS.ERROR]: '登録/変更に失敗しました。',
    [SERIAL_LINK_STATUS.SUCCESS]: '',
  };

export const SUBSCRIPTION_PURCHASED_TEXT =
  'サブスクリプション購入済み' as const;

export const CONTRACTED_TEXT = '契約済み' as const;

export type SerialLinkDialogContent = {
  linkName: string;
  title: string;
  buttonName: string;
  text: string;
  buttonTagName: string;
};

/**
 * シリアル登録時のシリアル連携ダイアログのコンテンツ
 */
export const SERIAL_REGISTRATION_CONTENT: SerialLinkDialogContent = {
  linkName: 'シリアルコードをお持ちの方はこちら',
  title: 'シリアル登録',
  buttonName: 'シリアル登録',
  text: '企業向けライセンスをお持ちの場合は、管理者から提供されたシリアルコードを入力してください。新しいプランが変更されます。',
  buttonTagName: 'dialog-26',
} as const;

/**
 * シリアル変更時のシリアル連携ダイアログのコンテンツ
 */
export const SERIAL_CHANGE_CONTENT: SerialLinkDialogContent = {
  linkName: 'プラン変更のシリアルコードを入力',
  title: 'シリアル変更',
  buttonName: 'シリアル変更',
  text: 'シリアルコードを変更する場合は、管理者から提供された新しいコードを入力してください。新しいプランが変更されます。',
  buttonTagName: 'dialog-27',
} as const;
